import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/portalmg.png'
import _imports_1 from '@/assets/svg/myimg_upload.svg'


const _withScopeId = n => (_pushScopeId("data-v-60741b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "right_content" }
const _hoisted_3 = { class: "mod_wrap" }
const _hoisted_4 = { class: "mod_c" }
const _hoisted_5 = { class: "mod_c_title picture_nav flex between" }
const _hoisted_6 = { class: "picture_head" }
const _hoisted_7 = { class: "mod_c_tbody select_none" }
const _hoisted_8 = { class: "picture_nav flex between" }
const _hoisted_9 = { class: "container_textLeft flex between" }
const _hoisted_10 = { class: "photo_btn" }
const _hoisted_11 = { class: "mod_nav_btn_title" }
const _hoisted_12 = { class: "picture_wrap" }
const _hoisted_13 = { class: "picture_container one" }
const _hoisted_14 = { class: "picture_container_img_wrap" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "picture_tip" }
const _hoisted_17 = { class: "picture_tip" }
const _hoisted_18 = { class: "picture_meta one" }
const _hoisted_19 = { class: "picture_meta_tbody meta_info" }
const _hoisted_20 = { class: "picture_meta_tbody_title" }
const _hoisted_21 = { class: "picture_meta_function flex between" }
const _hoisted_22 = { class: "picture_meta_function_edit" }
const _hoisted_23 = { class: "preview_img" }
const _hoisted_24 = { class: "list_content" }
const _hoisted_25 = { class: "list_view_line flex" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "line_content" }
const _hoisted_28 = { class: "line_function flex between" }
const _hoisted_29 = { class: "class_fication" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_color" }, "分类:", -1))
const _hoisted_31 = { class: "function_right flex between" }
const _hoisted_32 = { class: "big_more" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_color" }, "大小:", -1))
const _hoisted_34 = { class: "time" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_color" }, "时间:", -1))
const _hoisted_36 = { class: "different_function" }
const _hoisted_37 = { class: "preview_img" }
const _hoisted_38 = {
  key: 1,
  class: "list_null"
}
const _hoisted_39 = { class: "picture_bottoms" }
const _hoisted_40 = { class: "edit_message_box flex" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit_head" }, "上传分类:", -1))
const _hoisted_42 = { class: "edit_load" }
const _hoisted_43 = { class: "h5_up" }
const _hoisted_44 = {
  key: 0,
  src: "imageUrl",
  alt: "avatar"
}
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 1,
  class: "icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant_upload_text" }, "建议上传:750*1334", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant_upload_text" }, "建议大小:3MB", -1))
const _hoisted_49 = { class: "upload_class" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_class_title" }, "上传:", -1))
const _hoisted_51 = { class: "upload_imgs" }
const _hoisted_52 = { class: "img_up flex" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant_upload_text" }, "点击上传", -1))
const _hoisted_55 = { class: "ant_upload_text" }
const _hoisted_56 = ["src"]
const _hoisted_57 = {
  key: 1,
  class: "loading_text"
}
const _hoisted_58 = { class: "item_top" }
const _hoisted_59 = { class: "head" }
const _hoisted_60 = { class: "item_bottom" }
const _hoisted_61 = {
  key: 1,
  class: "item_picture flex"
}
const _hoisted_62 = { class: "picture_bottom flex between" }
const _hoisted_63 = { class: "picture_progree flex" }
const _hoisted_64 = { class: "total_memory" }
const _hoisted_65 = { class: "picture_capacity flex" }
const _hoisted_66 = { class: "used" }
const _hoisted_67 = { class: "surplus" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mod_nav_btn_title upgrade" }, "升级", -1))

import CDelModal from '@/components/CDelModal.vue';
import { VueDraggableNext } from 'vue-draggable-next';
import { useStore } from 'vuex';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import { getToken } from '@/plugins/cookie';
import { useRoute } from 'vue-router';
import { RootLive } from '@/store/modules/live/types';
import { moveSort, createSort, sortList } from './sortFunction';
import Crumb from '@/components/Crumb.vue';
import CMenu from '../components/CLeftMenu.vue';
import CAddCategoryVue from '../components/CAddCategory.vue';
import CMove from '../components/CMoveSort.vue';
import CLoading from '@/components/CLoading.vue';
import http from '@/api/conentCenter/communal';
import { useUpload } from './multipleUpload';
import emitter from '@/utils/mitt';
import { ElUpload } from 'element-plus';
interface LiveSearch {
  checked_all: boolean;
}

const __default__ = { name: '' };
import moment from 'moment';
import { ref, computed, reactive, watch } from 'vue';
import {
  Input,
  DatePicker,
  Modal,
  Image,
  Button,
  Pagination,
  Progress,
  Select,
  Radio,
  Popover,
  Upload,
  message,
} from 'ant-design-vue';
import { RightOutlined, LoadingOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { dragDrop } from '@/utils/format/dragDrop';

const aInputSearch = Input.Search;
const { RangePicker } = DatePicker;
const aRangePicker = RangePicker;
const aProgress = Progress;
const aButton = Button;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aModal = Modal;
const aPagination = Pagination;
const aUpload = Upload;
const aImage = Image;
const aPopover = Popover;
const aSelect = Select;
const ranges: any = {
  今天: [moment().startOf('day'), moment().endOf('day')],
  最近一周: [moment().startOf('day').subtract(1, 'weeks'), moment()],
  最近一月: [moment().startOf('day').subtract(1, 'months'), moment()],
  最近三月: [moment().startOf('day').subtract(3, 'months'), moment()],
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const gatewayId = route.params.gatewayId;
const draggable = VueDraggableNext;
const confirm = ref(false);
const isShow = ref(true);
const imageUrl = ref<string>('');
const Options = ref(1); // 上传弹窗模式
const select = ref(1);
const showLoading = ref<boolean>(false);
const { fileList, viewFileList, loading, clearFile, handleChange, beforeUpload } = useUpload({ type: 1 });

// 拖拽
const dragOptions = {
  animation: 0,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
};

const datafol = ref<any>([]);

// 上传
const UploadTxt = () => {
  confirm.value = true;
  getSortList();
};

const push_type = ref();

/** 获取分类列表 */
const { sortListArr, getSortList } = sortList({
  type: 2,
  gatewayId: gatewayId,
});

const saveAddFile = () => {
  createStatus.value = 0;
  viewFileList.value.forEach((item, index) => {
    addPortalFile(item, index);
  });
  confirm.value = false;
  push_type.value = sortId.value;
  setTimeout(() => {
    createStatus.value = 2;
    getFileList(1);
  }, 500);
  clearFile();
};

// 添加上传文件
const addPortalFile = async (file: any, index: number) => {
  let params = {
    sort_id: push_type.value,
    name: file.name,
    type: 1,
    size: file.size,
    file_link: file.url,
    format: file.format,
    portal_id: gatewayId,
  };
  await http.add_portal_file(params).then((res: any) => {
    viewFileList.value = [];
  });
};

const delFile = (index: number) => {
  viewFileList.value.splice(index, 1);
};

// 视图切换按钮
const modalVisible = ref(false);
const getCutoverIcon = computed(() => {
  return isShow.value ? 'list' : 'block';
});
const getCutoverName = computed(() => {
  return isShow.value ? '列表视图' : '缩略视图';
});
const switchView = () => {
  isShow.value = !isShow.value;
};
// 删除
const openDelModal = () => {
  modalVisible.value = true;
  let data: any = [];
  datafol.value.map((res: any) => {
    data.push(res.id);
  });
};
const closeDelModal = () => {
  modalVisible.value = false;
  sortSelectKeys.value = [];
  clear();
};
// 删除确定按钮
const studioIds: any = ref([]);
const removeLiveData = () => {
  createStatus.value = 0;
  let delPortal = {
    id: studioIds.value.join(','),
    type: 1,
    portal_id: gatewayId,
  };
  http
    .getDelPortalFile({ params: delPortal })
    .then((res) => {
      sortSelectKeys.value = [];
      getFileList(1);
      createStatus.value = 2;
      modalVisible.value = false;
      message.success(res.data.message);
    })
    .catch((res: any) => {
      sortSelectKeys.value = [];
      message.error(res.data.error);
      modalVisible.value = false;
    });
};

// 表格删除
const changeSelctPortalLive = (id: any) => {
  let arr = Object.keys(sortSelectKeys.value).filter((e) => sortSelectKeys.value[e] == true);
  id ? (modalVisible.value = true) : '';
  emitSelectedRowKeys();
  id ? studioIds.value.push(id) : (studioIds.value = arr);
};

const operation = reactive({
  use_time_filter: ref([]), // 使用记录时间筛选
  keyword: '',
});
// 清空
const clear = () => {
  queryForm.checked_all = false;
  studioIds.value = [];
};
//全选
const queryForm = reactive<LiveSearch>({
  checked_all: false,
});
const sortSelectKeys = ref([]);
const changeCheckAll = () => {
  if (queryForm.checked_all === true) {
    Object.keys(sortSelectKeys.value).forEach((k) => {
      sortSelectKeys.value[k] = true;
    });
  } else {
    Object.keys(sortSelectKeys.value).forEach((k) => {
      sortSelectKeys.value[k] = false;
    });
  }
  changeSelctPortalLive(0);
  emitSelectedRowKeys();
};

const sortId = ref();
const sortInfo = ref();
const getSortInfo = (data: any) => {
  sortInfo.value = data;
  sortId.value = data.id;
  push_type.value = data.id;
  getFileList(1);
  operation.use_time_filter = [];
};

//处理底部导致侧边栏出现滚动条的情况
const store = useStore();
const selectedKeys = ref<string[]>([]);
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
onBeforeRouteUpdate((to) => {
  selectedKeys.value = [to.path];
});
onBeforeRouteLeave(() => {
  store.commit('home/setCustomFooter', false);
});

// 获取文件列表
const getFileList = (current: number) => {
  queryForm.checked_all = false;
  showLoading.value = true;
  sortSelectKeys.value = [];
  clear();
  let gain = {
    type: 1,
    keyword: operation.keyword,
    start_at: operation.use_time_filter[0] ? new Date(operation.use_time_filter[0]) : operation.use_time_filter[0],
    end_at: operation.use_time_filter[1] ? new Date(operation.use_time_filter[1]) : operation.use_time_filter[1],
    sort_id: sortId.value,
    page: current,
    page_num: pageConfig.pageSize,
    portal_id: gatewayId,
  };
  http
    .getFileList({ params: gain })
    .then((res) => {
      pageConfig.current = res.data.data.current_page;
      pageConfig.totalSize = res.data.data.total;
      const degree = res.data.data.data;
      datafol.value = degree;
      datafol.value.map((e: RootLive) => {
        sortSelectKeys.value[e.id] = false;
        e['isEdit'] = false;
      });
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
};

// 编辑文件名称
const editFileName = (item: any) => {
  let editFile = {
    id: item.id,
    name: item.name,
    portal_id: gatewayId,
  };
  http
    .getEditFileName(editFile)
    .then((res) => {
      if (res.data.code == 200) {
        item.isEdit = false;
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      item.isEdit = false;
      message.destroy();
      message.error(res.data.error);
    });
};

const editTitle = ref();
const clickEdit = (item: any) => {
  item.isEdit = !item.isEdit;
  item.isEdit ? editTitle.value.blur() : editFileName(item);
};

// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 12, // 每页条数
  totalSize: 1, // 总数
  options: ['12', '24', '36', '48', '60'], // 选项
});

const moveSortId = ref();
const getMoveSortId = (data: any) => {
  moveSortId.value = data;
};

/**
 * 移动分类
 */
const emitSelectedRowKeys = () => {
  let arr = Object.keys(sortSelectKeys.value).filter((e) => sortSelectKeys.value[e] == true);
  emitter.emit('selectedRowKeys', arr);
};
const childRef = ref();
const { isMove, moveStatus, createMove } = moveSort({
  type: 2,
  gatewayId: gatewayId,
});
watch(
  () => moveStatus.value,
  () => {
    moveStatus.value == 2 && getFileList(1);
  }
);

const moveCategory = () => {
  isMove.value = true;
};
const closeMove = () => {
  isMove.value = !isMove.value;
};

/** */

/**
 * 添加分类
 */
const { isVisible, createStatus, getCreate } = createSort({
  gatewayId: gatewayId,
});

const addCategory = () => {
  isVisible.value = true;
};
const isopenDelModal = () => {
  isVisible.value = !isVisible.value;
};
/** */

// 获取文件占比
const totalRecource = ref('');
const remainingResources = ref('');
const percentage = ref();
const fileUseSize = ref('');
const portalFileResources = () => {
  let resource = {
    type: 1,
  };
  http.getPortalFileResources({ params: resource }).then((res) => {
    const target = res.data.data;
    totalRecource.value = target.total_resources;
    remainingResources.value = target.remaining_resources;
    percentage.value = target.percentage;
    fileUseSize.value = target.file_use_size;
  });
};
portalFileResources();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CMenu, {
        "data-source": { menuType: 2, createSort: _unref(createStatus), moveSort: _unref(moveStatus) },
        onSortInfo: getSortInfo
      }, null, 8, ["data-source"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(" 图片分类 / "),
                _withDirectives(_createElementVNode("span", { class: "sub_title" }, _toDisplayString(sortInfo.value?.name) + "(" + _toDisplayString(sortInfo.value?.count) + ")", 513), [
                  [_vShow, sortInfo.value?.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(aButton), { onClick: moveCategory }, {
                  default: _withCtx(() => [
                    _createTextVNode("移至分类"),
                    _createVNode(_unref(RightOutlined))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(aButton), {
                  class: "picture_mange actived",
                  onClick: addCategory
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加分类")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(aRangePicker), {
                      value: operation.use_time_filter,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((operation.use_time_filter) = $event)),
                      ranges: ranges,
                      "show-time": { format: 'HH:mm' },
                      format: "YYYY-MM-DD HH:mm",
                      class: "mod_range_picker",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (getFileList(1))),
                      onOk: _cache[2] || (_cache[2] = ($event: any) => (getFileList(1)))
                    }, {
                      suffixIcon: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_unref(aInputSearch), {
                      class: "mod_range_picker_search",
                      placeholder: "请输入标题名称",
                      value: operation.keyword,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((operation.keyword) = $event)),
                      onSearch: _cache[4] || (_cache[4] = ($event: any) => (getFileList(1)))
                    }, {
                      enterButton: _withCtx(() => [
                        _createVNode(_unref(SearchOutlined))
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_unref(aButton), {
                      type: "primary",
                      onClick: UploadTxt
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("上传")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_unref(aButton), {
                      type: "link",
                      onClick: switchView
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "btn_icon",
                          "icon-class": _unref(getCutoverIcon)
                        }, null, 8, ["icon-class"])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getCutoverName)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_checkbox, {
                      checked: queryForm.checked_all,
                      "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.checked_all) = $event)),
                      class: "cache_check",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (changeCheckAll()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("全选")
                      ]),
                      _: 1
                    }, 8, ["checked"]),
                    _createVNode(_unref(aButton), {
                      type: "link",
                      danger: "",
                      class: "mod_btn",
                      disabled: studioIds.value.length == 0,
                      onClick: openDelModal
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "mod_btn_icon",
                          "icon-class": "del"
                        })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _withDirectives(_createVNode(_unref(draggable), _mergeProps({
                  handle: ".mover",
                  class: "picture_tab",
                  list: datafol.value
                }, dragOptions, {
                  disabled: datafol.value.length < 1,
                  onDrop: _unref(dragDrop)
                }), {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datafol.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "picture_wrap_content"
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("img", {
                                class: "picture_container_img",
                                src: item.file_link
                              }, null, 8, _hoisted_15)
                            ]),
                            _createElementVNode("div", {
                              class: "picture_menu_top",
                              style: _normalizeStyle(sortSelectKeys.value[item.id] ? 'display:block' : '')
                            }, [
                              _withDirectives(_createVNode(_component_svg_icon, {
                                class: "mover",
                                "icon-class": "drag_icon"
                              }, null, 512), [
                                [_vShow, datafol.value.length > 1]
                              ]),
                              _createVNode(_component_a_checkbox, {
                                checked: sortSelectKeys.value[item.id],
                                "onUpdate:checked": ($event: any) => ((sortSelectKeys.value[item.id]) = $event),
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (changeSelctPortalLive('')))
                              }, null, 8, ["checked", "onUpdate:checked"])
                            ], 4),
                            _createElementVNode("div", {
                              class: "picture_menu_wrap",
                              style: _normalizeStyle(sortSelectKeys.value[item.id] ? 'display:block' : '')
                            }, [
                              _createElementVNode("div", _hoisted_16, "大小:" + _toDisplayString(item.size), 1),
                              _createElementVNode("div", _hoisted_17, "日期:" + _toDisplayString(item.created_at), 1)
                            ], 4)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("p", { class: "text" }, _toDisplayString(item.name), 513), [
                                  [_vShow, !item.isEdit]
                                ]),
                                _withDirectives(_createVNode(_component_a_input, {
                                  class: "edit_input",
                                  ref_for: true,
                                  ref_key: "editTitle",
                                  ref: editTitle,
                                  value: item.name,
                                  "onUpdate:value": ($event: any) => ((item.name) = $event),
                                  onBlur: ($event: any) => (editFileName(item)),
                                  onPressEnter: ($event: any) => (editFileName(item))
                                }, null, 8, ["value", "onUpdate:value", "onBlur", "onPressEnter"]), [
                                  [_vShow, item.isEdit]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_svg_icon, {
                                    "icon-class": "content_live_edit",
                                    class: "picture_edit",
                                    onClick: ($event: any) => (clickEdit(item)),
                                    style: _normalizeStyle(item.isEdit ? 'color:#01a2e9' : '')
                                  }, null, 8, ["onClick", "style"]),
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_unref(aImage), {
                                      width: 14,
                                      src: item.file_link
                                    }, null, 8, ["src"]),
                                    _createVNode(_component_svg_icon, {
                                      "icon-class": "content _live_big",
                                      class: "picture_look cursor"
                                    })
                                  ])
                                ]),
                                _createVNode(_component_svg_icon, {
                                  "icon-class": "content_live_del",
                                  class: "icon_del cursor",
                                  onClick: ($event: any) => (!queryForm.checked_all ? changeSelctPortalLive(item.id) : '')
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 16, ["list", "disabled", "onDrop"]), [
                  [_vShow, isShow.value]
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datafol.value, (item) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "list_view flex",
                      key: item
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_checkbox, {
                          checked: sortSelectKeys.value[item.id],
                          "onUpdate:checked": ($event: any) => ((sortSelectKeys.value[item.id]) = $event),
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (changeSelctPortalLive('')))
                        }, null, 8, ["checked", "onUpdate:checked"]),
                        _createElementVNode("img", {
                          class: "line_img",
                          src: item.file_link,
                          alt: ""
                        }, null, 8, _hoisted_26),
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("p", null, _toDisplayString(item.name), 513), [
                            [_vShow, !item.isEdit]
                          ]),
                          _withDirectives(_createVNode(_component_a_input, {
                            class: "edit_input",
                            ref_for: true,
                            ref_key: "editTitle",
                            ref: editTitle,
                            value: item.name,
                            "onUpdate:value": ($event: any) => ((item.name) = $event),
                            onBlur: ($event: any) => (editFileName(item)),
                            onPressEnter: ($event: any) => (editFileName(item))
                          }, null, 8, ["value", "onUpdate:value", "onBlur", "onPressEnter"]), [
                            [_vShow, item.isEdit]
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _hoisted_30,
                              _createTextVNode("   " + _toDisplayString(item.sort_name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createTextVNode("   " + _toDisplayString(item.size), 1)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createTextVNode("   " + _toDisplayString(item.created_at), 1)
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_svg_icon, {
                                  "icon-class": "content_live_edit",
                                  class: "picture_edit",
                                  style: _normalizeStyle(item.isEdit ? 'color:#01a2e9' : ''),
                                  onClick: ($event: any) => (clickEdit(item))
                                }, null, 8, ["style", "onClick"]),
                                _createElementVNode("div", _hoisted_37, [
                                  _createVNode(_unref(aImage), {
                                    width: 14,
                                    src: item.file_link
                                  }, null, 8, ["src"]),
                                  _createVNode(_component_svg_icon, {
                                    "icon-class": "content _live_big",
                                    class: "picture_look cursor"
                                  })
                                ]),
                                _createVNode(_component_svg_icon, {
                                  "icon-class": "content_live_del",
                                  class: "icon_del cursor",
                                  onClick: ($event: any) => (!queryForm.checked_all ? changeSelctPortalLive(item.id) : '')
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])), [
                      [_vShow, !isShow.value]
                    ])
                  }), 128))
                ]),
                (showLoading.value)
                  ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
                  : (datafol.value.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(_component_svg_icon, { "icon-class": "content_picture" })
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_39, [
                  (datafol.value.length !== 0)
                    ? (_openBlock(), _createBlock(_unref(aPagination), {
                        key: 0,
                        "show-quick-jumper": "",
                        total: pageConfig.totalSize,
                        current: pageConfig.current,
                        "onUpdate:current": _cache[9] || (_cache[9] = ($event: any) => ((pageConfig.current) = $event)),
                        "page-size": pageConfig.pageSize,
                        "onUpdate:pageSize": _cache[10] || (_cache[10] = ($event: any) => ((pageConfig.pageSize) = $event)),
                        pageSizeOptions: pageConfig.options,
                        "show-less-items": "",
                        "show-size-changer": "",
                        onShowSizeChange: _cache[11] || (_cache[11] = ($event: any) => (getFileList(pageConfig.current))),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (getFileList(pageConfig.current)))
                      }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(_unref(aModal), {
              visible: confirm.value,
              "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((confirm).value = $event)),
              title: "图片上传",
              centered: "",
              onOk: saveAddFile,
              onCancel: _cache[16] || (_cache[16] = ($event: any) => ((viewFileList.value = []), _unref(clearFile)())),
              okText: "确定",
              width: "688px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "edit_message",
                  style: _normalizeStyle(select.value == 2 ? 'overflowY:visible' && 'maxHeight:400px' : '')
                }, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_unref(aSelect), {
                        class: "mod_select selected",
                        value: push_type.value,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((push_type).value = $event)),
                        placeholder: "请选择分类"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortListArr), (i) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: i.id,
                              value: i.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(i.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", {
                    class: "upload_img",
                    style: _normalizeStyle({ height: select.value == 2 ? '377px' : '' })
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_unref(aUpload), {
                        "file-list": _unref(fileList),
                        "onUpdate:fileList": _cache[14] || (_cache[14] = ($event: any) => (_isRef(fileList) ? (fileList).value = $event : null)),
                        name: "avatar",
                        "list-type": "picture-card",
                        class: "avatar_uploader",
                        "show-upload-list": false,
                        accept: ".jpg,.jpeg,.png,.gif",
                        action: "/api/v1/common/upload_images"
                      }, {
                        default: _withCtx(() => [
                          (imageUrl.value)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_44))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                (_unref(loading))
                                  ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                                  : (_openBlock(), _createElementBlock("img", _hoisted_46)),
                                _hoisted_47,
                                _hoisted_48
                              ]))
                        ]),
                        _: 1
                      }, 8, ["file-list"])
                    ])
                  ], 4), [
                    [_vShow, Options.value == 0]
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _withDirectives(_createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_unref(ElUpload), {
                          class: _normalizeClass([_unref(viewFileList).length == 0 ? 'upload_screen' : 'upload', "avatar_uploader"]),
                          drag: "",
                          name: "images",
                          headers: { token: _unref(getToken) },
                          action: "/api/v1/common/upload_images",
                          multiple: "",
                          accept: ".jpg,.jpeg,.png,.gif",
                          "show-file-list": false,
                          "file-list": _unref(fileList),
                          "http-request": _unref(handleChange),
                          "before-upload": _unref(beforeUpload)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_53,
                            _hoisted_54,
                            _withDirectives(_createElementVNode("div", _hoisted_55, "支持拖拽上传，建议大小:3MB", 512), [
                              [_vShow, _unref(viewFileList).length == 0]
                            ])
                          ]),
                          _: 1
                        }, 8, ["class", "headers", "file-list", "http-request", "before-upload"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewFileList), (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "img_item",
                            key: index
                          }, [
                            (item.url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: item.url,
                                  alt: ""
                                }, null, 8, _hoisted_56))
                              : (_openBlock(), _createElementBlock("div", _hoisted_57, "上传中")),
                            _withDirectives(_createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, _toDisplayString(item.name), 1)
                            ], 512), [
                              [_vShow, !item.isShow]
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              (!item.isShow)
                                ? (_openBlock(), _createBlock(_unref(aProgress), {
                                    key: 0,
                                    percent: item.percentage,
                                    size: "small"
                                  }, null, 8, ["percent"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                    _createVNode(_component_svg_icon, {
                                      class: "mod_btn_icon cursor",
                                      "icon-class": "del",
                                      onClick: ($event: any) => (delFile(index))
                                    }, null, 8, ["onClick"])
                                  ]))
                            ])
                          ]))
                        }), 128))
                      ])
                    ], 512), [
                      [_vShow, Options.value == 1]
                    ])
                  ])
                ], 4)
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(CDelModal, {
              visible: modalVisible.value,
              centered: "",
              close: closeDelModal,
              ok: removeLiveData
            }, null, 8, ["visible"])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_unref(aProgress), {
                percent: percentage.value,
                showInfo: false,
                class: "prgress",
                trailColor: "#dde1e7"
              }, null, 8, ["percent"])
            ]),
            _createElementVNode("div", _hoisted_64, "总内存:" + _toDisplayString(totalRecource.value), 1),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createTextVNode(" 已使用:"),
                _createElementVNode("span", null, _toDisplayString(fileUseSize.value), 1)
              ]),
              _createElementVNode("div", _hoisted_67, "剩余:" + _toDisplayString(remainingResources.value), 1)
            ]),
            _createVNode(_unref(aButton), { class: "mod_btn_primary actived purchase_btn" }, {
              icon: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  class: "mod_nav_btn_icon",
                  "icon-class": "purchase"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: { path: `/wallet/resource`, query: { pageIndex: 4 } },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _hoisted_68
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
          [_vShow, _unref(customFootStyle)]
        ])
      ])
    ]),
    _createVNode(CAddCategoryVue, {
      visible: _unref(isVisible),
      close: isopenDelModal,
      ok: _unref(getCreate),
      centered: ""
    }, null, 8, ["visible", "ok"]),
    _createVNode(CMove, {
      ref_key: "childRef",
      ref: childRef,
      "data-source": { menuType: 2, moveStatus: _unref(moveStatus) },
      visible: _unref(isMove),
      close: closeMove,
      ok: _unref(createMove),
      onMoveSortId: getMoveSortId,
      centered: "",
      onSortInfo: getSortInfo
    }, null, 8, ["data-source", "visible", "ok"])
  ]))
}
}

})